// extracted by mini-css-extract-plugin
export default {"recos":"j5-z","productCardOverride":"k5-z","rowHasBadge":"l5-z"};